<template>
<div class="col m-0 p-0 g-0">
    <div
        class="row row-cols-2 half-transparent-border m-0 px-0"
        :class="{'triangle-mark clickable': activityLabel}"
        style="padding-top: 3px; padding-bottom: 3px;"
    >
        <div class="col text-start text-nowrap metric-name-text vidget-field">
            {{ name === undefined ? "&nbsp;" : name }}
        </div>

        <div class="col text-end text-nowrap metric-value-text vidget-field">
            <unit-icon v-if="icon !== undefined" :unitType="icon" edgeSize="17" />
            {{ value === undefined ? "&nbsp;" : value }}
            {{ unit === undefined ? "": "&nbsp;" + unit }}
        </div>
    </div>
</div>
</template>


<script>
import UnitIcon from '@/components/Icons/UnitIcon.vue'

export default {
    components: {
		UnitIcon,
    },

    props: {
		name: {
			type: String,
			required: false,
            default: undefined,
		},
        icon: {
            type: String,
			required: false,
            default: undefined,
        },
        value: {
            type: String || Number,
			required: false,
            default: undefined,
        },
        unit: {
            type: String,
			required: false,
            default: undefined,
        },
        // Triangle mark on the right side of the vidget and make vidget clickable
        activityLabel: {
            type: Boolean,
            required: false,
            default: false,
        }
	},
}
</script>


<style src="@/assets/widget.css" scoped></style>
<style>
    .vidget-field {
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>